// Dependencies
import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
// Components
import LoadingFallback from '../../components/common/LoadingFallback';

const Navbar = React.lazy(() => import('../../components/navbar/Navbar'));
const ZendeskWidget = React.lazy(() => import('../../components/widgets/ZendeskWidget'));

function Dashboard() {
  const { user } = useSelector((state) => state.auth);

  if (!user) {
    return <LoadingFallback />;
  }

  return (
    <div>
      <Suspense fallback={<LoadingFallback />}>
        <Navbar />
        <Outlet />
        {!!user.givenName && (
          <ZendeskWidget
            givenName={user.givenName}
            familyName={user.familyName}
            email={user.email}
          />
        )}
      </Suspense>
    </div>
  );
}

export default Dashboard;
